import { render, staticRenderFns } from "./ServiceCommentBlock.vue?vue&type=template&id=1c738e14&scoped=true"
import script from "./ServiceCommentBlock.vue?vue&type=script&lang=ts"
export * from "./ServiceCommentBlock.vue?vue&type=script&lang=ts"
import style0 from "./ServiceCommentBlock.vue?vue&type=style&index=0&id=1c738e14&prod&lang=scss&scoped=true"
import style1 from "./ServiceCommentBlock.vue?vue&type=style&index=1&id=1c738e14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c738e14",
  null
  
)

export default component.exports